module.exports = __webpack_public_path__ + "static/media/bg.6d36b049.png";